import { createSelector } from 'reselect';

const selectAlerts = state => state.alerts;

export const selectAlertInAlert = createSelector(
  [selectAlerts],
  alerts => alerts.errors
);